import React, { useContext, useState } from "react";
import styled from "styled-components";
import { LinkContext } from "../../contexts/LinkContext";
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
`;

const Viz = styled.div`
  display: flex;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
  background-color: rgb(24, 29, 37);
  padding: 0.5em;
  color: #babfcb;
  align-items: center;
  min-height: 80px;
  min-width: 400px;
  width: 400px;
  padding: 1em;
  justify-content: center;
  flex-direction: column;
  border: ${(props) => (props.selected ? "1px solid #0adb93" : "")};
  margin: 10px;
  :hover {
    cursor: pointer;
  }
`;

const Connected = styled.div`
  display: flex;
  width: 10px;
  height: 10px;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 10%);
  background-color: ${(props) => (props.connected ? "#0adb93" : "red")};
  border-radius: 50%;
  margin: 1em;
`;

function Main() {
  const { viz, commands } = useContext(LinkContext);
  const [selectedViz, setSelectedViz] = useState();

  function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

  return (
    <Row>
      {[...new Set(viz.map((item) => item.ip))]?.map((ip) => {
        return (
          <Viz
            selected={ip === selectedViz}
            onClick={() => {
              if (ip === selectedViz) {
                setSelectedViz();
              } else {
                setSelectedViz(ip);
              }
            }}
          >
            <Column>
              Viz ip: {ip}
              <Row>
                {viz
                  ?.filter((v2) => v2.ip === ip)
                  ?.map((v) => {
                    return (
                      <Row>
                        <Connected connected={v?.status === "connected"} />
                        {v?.port}
                      </Row>
                    );
                  })}
              </Row>
            </Column>
          </Viz>
        );
      })}
      {selectedViz && (
        <div>
          {commands?.map((command) => {
            return <Row>{command}</Row>;
          })}
        </div>
      )}
    </Row>
  );
}

export default Main;
